<template>
  <div class="renew-list-container">
    <!-- Loading state -->
    <div v-if="!servicesPopulated" class="d-flex justify-center py-8">
      <v-progress-circular
        indeterminate
        color="primary"
        size="62"
      ></v-progress-circular>
    </div>

    <!-- No eligible services -->
    <div v-else-if="eligibleServices.length === 0" class="text-center py-8">
      <v-icon color="grey" size="64">mdi-information-outline</v-icon>
      <h4 class="mt-3 grey--text">No services available for early renewal</h4>
      <p class="grey--text text--darken-1">
        You don't have any services eligible for early renewal at this time.
      </p>
    </div>

    <!-- Eligible services grid -->
    <template v-else>
      <p class="mb-5 text-center">
        Select a service below to view renewal options and lock in savings.
      </p>
      <v-row justify="center">
        <v-col
          v-for="service in eligibleServices"
          :key="service.id"
          cols="12"
          sm="6"
          lg="4"
          class="d-flex"
        >
          <renew-service-tile
            :service="service"
            class="flex-grow-1"
            @click="openRenewalModal(service)"
          />
        </v-col>
      </v-row>
    </template>

    <renew-now-modal
      v-if="selectedServiceId"
      ref="renewNowModal"
      :service-id="selectedServiceId"
      :preferred-term="preferredTerm"
      @renewal-complete="handleRenewalComplete"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RenewServiceTile from './RenewServiceTile.vue'
import RenewNowModal from '@/components/Services/Hosting/Shared/Overview/RenewNowModal.vue'
import { getServiceRouteType } from '@/helpers/helpers'
import { serviceBasePath } from '@/helpers/serverPaths'
import { SERVICE_TYPES } from '@/consts/service'

export default {
  name: 'RenewList',

  components: {
    RenewServiceTile,
    RenewNowModal,
  },

  data () {
    return {
      selectedServiceId: null,
    }
  },

  computed: {
    ...mapGetters(['services', 'servicesPopulated']),
    eligibleServices () {
      const allowedTypes = [SERVICE_TYPES.CPANEL, SERVICE_TYPES.RESELLER]
      return this.services
        .filter(s => {
          const cost = parseFloat(s.renewalcost) || 0
          return s.status === 'Active' &&
            s.can_access_early_renewal &&
            allowedTypes.includes(s.type) &&
            cost > 0
        })
        .sort((a, b) => new Date(a.renewaldate) - new Date(b.renewaldate))
    },
    preferredTerm () {
      return this.$route.query.term || 'annually'
    },
  },

  methods: {
    openRenewalModal (service) {
      this.selectedServiceId = service.id
      this.$nextTick(() => {
        this.$refs.renewNowModal.showModal()
      })
    },
    handleRenewalComplete ({ serviceId, serviceType }) {
      const routeType = getServiceRouteType({ type: serviceType })
      this.$router.push({
        path: serviceBasePath(routeType, serviceId),
      })
    },
  },
}
</script>

<style scoped lang="scss">
.renew-list-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 16px;
}
</style>
